import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Rect } from "react-native-svg";

export const IconControllerButtonSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconControllerButtonSquare"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Rect x="7.5" y="7.5" width="9" height="9" stroke="currentColor"/></CentralIconBase>;
});

export default IconControllerButtonSquare;
